import { useScrollIntent } from 'providers/ScrollIntentProvider';
import { useEffect, useRef } from 'react';
import type { ScrollIntent } from 'utils/scroll/scrollIntent';

const defaultSettings: ScrollIntoViewOptions = { behavior: 'smooth' };

type UseHashScrollProps = {
  /** Whatever the anchors render from: the scroll waits until they exist. */
  elementsWithId: unknown[];
  scrollSettings?: ScrollIntoViewOptions;
  ready?: boolean;
};

export default function useHashScroll({
  elementsWithId,
  scrollSettings = defaultSettings,
  ready = true,
}: UseHashScrollProps) {
  const intent = useScrollIntent();
  // Once per navigation, so later re-renders don't pull the page back
  const landedRef = useRef<ScrollIntent>();

  useEffect(() => {
    if (intent.kind !== 'hash' || !ready || landedRef.current === intent) {
      return;
    }

    const target = document.getElementById(intent.id);
    if (!target) return;

    landedRef.current = intent;
    target.scrollIntoView(scrollSettings);
  }, [intent, elementsWithId.length, ready, scrollSettings]);
}
